<template>
  <nav class="flex">
    <div class="bg-gray-300 w-16">
      <span v-if="fetchingCompanies">
        <base-loading
          class="block px-4 py-2 text-center text-xl text-gray-700"
        />
      </span>
      <div v-else>
        <router-link
          v-if="isAdmin"
          :to="
            isCompanyAdmin
              ? { name: 'dashboard-links' }
              : { name: 'admin-general' }
          "
          class="block w-full px-4 py-2 text-xl text-gray-700 text-center hover:text-blue-400"
          :class="{ 'text-blue-400': isCompanyAdmin }"
        >
          <span v-show="isCompanyAdmin">
            <icon-close title="Exit Company Admin"
          /></span>
          <span v-show="!isCompanyAdmin">
            <icon-cog title="Company Admin" />
          </span>
        </router-link>
        <AppNavSideButton
          v-for="company in companies"
          :key="company.id"
          :active="company.id === currentCompanyId"
          activeClass="bg-gray-200"
          @click="changeCompany(company.id)"
          :tooltip="company.name"
        >
          {{ company.short_name || company.name.substr(0, 2) }}
        </AppNavSideButton>
      </div>
      <router-link
        :to="{ name: 'company-create' }"
        class="block w-full p-2 text-2xl text-gray-700 text-center hover:text-blue-400"
        active-class="text-blue-400"
      >
        <icon-plus title="Create New Company" />
      </router-link>
    </div>

    <div class="bg-gray-200 w-16">
      <span v-if="fetchingCompanies || fetchingSegments">
        <base-loading
          class="block px-4 py-2 text-center text-xl text-gray-700"
        />
      </span>
      <div v-else>
        <router-link
          v-if="isAdmin"
          :to="
            isSegmentAdmin
              ? { name: 'dashboard-links' }
              : { name: 'segment-admin-general' }
          "
          class="block w-full px-4 py-2 text-xl text-gray-700 text-center hover:text-blue-400"
          :class="{ 'text-blue-400': isSegmentAdmin }"
        >
          <icon-close v-if="isSegmentAdmin" title="Exit Segment Admin" />
          <icon-cog v-else title="Segment Admin" />
        </router-link>
        <AppNavSideButton
          v-for="segment in segments"
          :key="segment.id"
          :active="!isCompanyAdmin && segment.id === currentSegmentId"
          activeClass="bg-gray-100"
          @click="changeSegment(segment.id)"
          :tooltip="segment.name"
        >
          {{ segment.short_name || segment.name.substr(0, 2) }}
        </AppNavSideButton>
      </div>
      <router-link
        :to="{ name: 'segment-create' }"
        class="block w-full p-2 text-2xl text-gray-700 text-center hover:text-blue-400"
        active-class="text-blue-400"
      >
        <icon-plus title="Create New Segment" />
      </router-link>
    </div>
  </nav>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import AppNavSideButton from './AppNavSideButton';

export default {
  components: { AppNavSideButton },
  computed: {
    ...mapState({
      fetchingCompanies: (state) => state.company.fetchingList,
      companies: (state) => state.company.list,
      currentCompanyId: (state) => state.company.currentId,
      fetchingSegments: (state) => state.company.segment.fetchingList,
      segments: (state) => state.company.segment.list,
      currentSegmentId: (state) => state.company.segment.currentId,
    }),
    ...mapGetters('auth', ['isAdmin']),
    isCompanyAdmin() {
      return !this.isSegmentAdmin && this.$route.path.indexOf('admin') !== -1;
    },
    isSegmentAdmin() {
      return this.$route.path.indexOf('segment-admin') !== -1;
    },
    isDashboardLinks() {
      return this.$route.name === 'dashboard-links';
    },
  },
  methods: {
    changeCompany(id) {
      this.$store.dispatch('company/changeCompany', id);
      if (!this.isDashboardLinks && !this.isCompanyAdmin) {
        this.$router.push({ name: 'dashboard-links' });
      }
    },
    changeSegment(id) {
      this.$store.dispatch('company/segment/changeSegment', id);
      if (!this.isDashboardLinks && !this.isSegmentAdmin) {
        this.$router.push({ name: 'dashboard-links' });
      }
    },
  },
};
</script>
